import React from "react";
import { Progress } from "antd";
import { STATE_STATUS } from "constants";
import PropTypes from "prop-types";
export default (comp, key, actions) =>
    class extends React.Component {
        componentWillMount() {
            if (this.props[key] === STATE_STATUS.UNFETCHED) {
                actions[STATE_STATUS.UNFETCHED].forEach(_ => {
                    if (typeof _.func === "string") {
                        this.props[_.func](..._.params);
                    }
                });
            }
        }
        render() {
            const { props } = this;
            if (
                key === STATE_STATUS.UNFETCHED ||
                key === STATE_STATUS.FETCHING
            ) {
                return (
                    <div
                        className={
                            "d-flex h-100 justify-content-center align-items-center"
                        }
                    >
                        <div
                            style={{
                                width: 300
                            }}
                        >
                            <Progress
                                percent={50}
                                status="active"
                                showInfo={false}
                            />
                        </div>
                    </div>
                );
            }
            return React.createElement(comp, props);
        }
        static propTypes = {
            children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
        };
        static displayName = "LoaderSkeleton";
    };
